<template>
  <div>
    <report-options />
  </div>
</template>

<script>
import ReportOptions from "@/components/ReportOptions";
export default {
  name: "reports",
  components: {
    ReportOptions
  },
  data: () => ({
    reportUrl: null
  })
};
</script>
